import { render } from "./TheTopHeaderDropDownMenuProfileEditProfileModalChangeLangModal.vue?vue&type=template&id=12ad3d2c"
import script from "./TheTopHeaderDropDownMenuProfileEditProfileModalChangeLangModal.vue?vue&type=script&lang=js"
export * from "./TheTopHeaderDropDownMenuProfileEditProfileModalChangeLangModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__